import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { deleteTerminalMasterApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const deleteTerminal = createAsyncThunk('deleteTerminal', async (payload) => {
  return await deleteTerminalMasterApi(payload);
});

const deleteTerminalSlice = createSlice({
  name: 'deleteTerminal', // Unique Name
  initialState,
  reducers: {
    deleteTerminalReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteTerminal.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(deleteTerminal.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(deleteTerminal.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { deleteTerminalReset } = deleteTerminalSlice.actions;

export default deleteTerminalSlice.reducer;
